"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Organizers = /** @class */ (function (_super) {
    __extends(Organizers, _super);
    function Organizers() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Organizers.prototype.render = function () {
        if (this.props.match.params.challenge == "ICASSP2021") {
            return (React.createElement("div", null,
                React.createElement("p", null,
                    React.createElement("b", null, "Chandan K A Reddy"),
                    ", Microsoft Corp, USA "),
                React.createElement("p", null,
                    React.createElement("b", null, "Hari Dubey"),
                    ", Microsoft Corp, USA "),
                React.createElement("p", null,
                    React.createElement("b", null, "Ross Cutler"),
                    ", Microsoft Corp, USA  "),
                React.createElement("p", null,
                    React.createElement("b", null, "Vishak Gopal"),
                    ", Microsoft Corp, USA "),
                React.createElement("p", null,
                    React.createElement("b", null, "Robert Aichner"),
                    ", Microsoft Corp, USA "),
                React.createElement("p", null,
                    React.createElement("b", null, "Sebastian Braun"),
                    ", Microsoft Research, Germany "),
                React.createElement("p", null,
                    React.createElement("b", null, "Hannes Gamper"),
                    ", Microsoft Research, USA "),
                React.createElement("p", null,
                    React.createElement("b", null, "Sriram Srinivasan"),
                    ", Microsoft Corp, USA ")));
        }
        else {
            return (React.createElement("div", null,
                React.createElement("p", null,
                    React.createElement("b", null, "Chandan K A Reddy"),
                    ", Microsoft Corp, USA "),
                React.createElement("p", null,
                    React.createElement("b", null, "Hari Dubey"),
                    ", Microsoft Corp, USA "),
                React.createElement("p", null,
                    React.createElement("b", null, "Ross Cutler"),
                    ", Microsoft Corp, USA  "),
                React.createElement("p", null,
                    React.createElement("b", null, "Johannes Gehrke"),
                    ", Microsoft Corp, USA "),
                React.createElement("p", null,
                    React.createElement("b", null, "Vishak Gopal"),
                    ", Microsoft Corp, USA "),
                React.createElement("p", null,
                    React.createElement("b", null, "Robert Aichner"),
                    ", Microsoft Corp, USA ")));
        }
    };
    return Organizers;
}(React.Component));
exports.default = react_redux_1.connect()(Organizers);
//# sourceMappingURL=Organizers.js.map